<mat-form-field floatLabel="always" style="width: 10rem">
  <mat-label>{{ label }}</mat-label>
  <!--
      [disableDialogOpenOnClick]="true"
    -->
  <input
    matInput
    [id]="id"
    mode="24h"
    okLabel="OK"
    cancelLabel="Abbrechen"
    [ngModel]="_valueTxt"
    (ngModelChange)="timeChangeHandler($event)"
    [required]="_required"
    [name]="id"
    (timeChange)="timeChangeHandler($event)"
    (invalidInput)="invalidInputHandler()"
  />
  <!-- Will open the timepicker dialog when clicked -->
  <mat-icon matSuffix (click)="showDialog()">access_time</mat-icon>
</mat-form-field>
